export default "__VITE_ASSET__Cg7wNyLy__"